var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"rh-auth"},[_c('section',{staticClass:"rh-panel"},[_c('img',{attrs:{"src":_vm.logo,"alt":"MetaVirtue"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }